import { formatNumber } from './number';

export type PercentInputSemantics = 'whole' | 'ratio';

export type FormatPercentOptions = {
  /** `whole`: 25 → 25%; `ratio`: 0.25 → 25%. Default whole (matches most UI). */
  semantics?: PercentInputSemantics;
  locale?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  nullDisplay?: string;
};

export function formatPercent(value: unknown, options: FormatPercentOptions = {}): string {
  if (value === null || value === undefined) return options.nullDisplay ?? '';
  const n = Number(value);
  if (!Number.isFinite(n)) return options.nullDisplay ?? '';
  const semantics = options.semantics ?? 'whole';
  const asWhole = semantics === 'ratio' ? n * 100 : n;
  const formatted = formatNumber(asWhole, {
    locale: options.locale,
    minimumFractionDigits: options.minimumFractionDigits ?? 0,
    maximumFractionDigits: options.maximumFractionDigits ?? 2,
  });
  return `${formatted}%`;
}
